module.exports = __webpack_public_path__ + "img/logo-outlook-duplicate-remover.75f9300.png";